// extracted by mini-css-extract-plugin
export default {"Settings":"Settings_Settings__pXXcy"};